export default "__VITE_ASSET__DND2zulQ__"